var _rect, _text, _text2, _ellipse, _text3, _line, _line2, _line3, _line4, _rect2, _text4, _rect3, _text5, _rect4, _text6, _rect5, _text7, _text8, _text9, _line5, _text10, _rect6, _text11, _line6, _polygon, _rect7, _text12, _line7, _polygon2, _rect8, _text13, _text14, _line8, _polygon3, _rect9, _text15, _line9, _line10, _line11, _line12, _rect10, _text16, _rect11, _text17, _rect12, _text18, _rect13, _text19, _text20, _text21, _text22, _rect14, _text23, _text24, _text25;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContextEngineeringGraph(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 500",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ceBoxGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#1a1a1a",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#111111",
      stopOpacity: 1
    }
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 500,
    rx: 8,
    fill: "#0C0C0C",
    stroke: "#DCCA87",
    strokeOpacity: 0.15,
    strokeWidth: 1
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 32,
    textAnchor: "middle",
    fontFamily: "monospace",
    fontSize: 11,
    fill: "#DCCA87",
    letterSpacing: 2,
    opacity: 0.7
  }, "CONTEXT LOCALITY \u2014 GRAPH-INDUCED CONTEXT CONSTRUCTION")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 190,
    y: 68,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 10,
    fill: "#AAAAAA",
    letterSpacing: 1
  }, "TRADITIONAL (PER-AGENT RETRIEVAL)")), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 190,
    cy: 110,
    rx: 60,
    ry: 24,
    fill: "none",
    stroke: "#666666",
    strokeWidth: 1
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 190,
    y: 114,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 11,
    fill: "#AAAAAA"
  }, "Repository (|G|)")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 130,
    y1: 134,
    x2: 80,
    y2: 170,
    stroke: "#666666",
    strokeWidth: 1,
    strokeDasharray: "3,3"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 160,
    y1: 134,
    x2: 140,
    y2: 170,
    stroke: "#666666",
    strokeWidth: 1,
    strokeDasharray: "3,3"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 220,
    y1: 134,
    x2: 240,
    y2: 170,
    stroke: "#666666",
    strokeWidth: 1,
    strokeDasharray: "3,3"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 250,
    y1: 134,
    x2: 300,
    y2: 170,
    stroke: "#666666",
    strokeWidth: 1,
    strokeDasharray: "3,3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 172,
    width: 70,
    height: 36,
    rx: 3,
    fill: "none",
    stroke: "#666666",
    strokeWidth: 1
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 80,
    y: 192,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 9,
    fill: "#AAAAAA"
  }, "Security")), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 172,
    width: 70,
    height: 36,
    rx: 3,
    fill: "none",
    stroke: "#666666",
    strokeWidth: 1
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 160,
    y: 192,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 9,
    fill: "#AAAAAA"
  }, "Correctness")), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 205,
    y: 172,
    width: 70,
    height: 36,
    rx: 3,
    fill: "none",
    stroke: "#666666",
    strokeWidth: 1
  })), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 240,
    y: 192,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 9,
    fill: "#AAAAAA"
  }, "Performance")), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 285,
    y: 172,
    width: 70,
    height: 36,
    rx: 3,
    fill: "none",
    stroke: "#666666",
    strokeWidth: 1
  })), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 320,
    y: 192,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 9,
    fill: "#AAAAAA"
  }, "Testing")), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 190,
    y: 230,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 10,
    fill: "#666666"
  }, "Cost: O(N \xD7 |G| \xD7 k)")), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 190,
    y: 246,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 9,
    fill: "#666666"
  }, "Each agent retrieves independently")), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 395,
    y1: 55,
    x2: 395,
    y2: 260,
    stroke: "#DCCA87",
    strokeOpacity: 0.2,
    strokeWidth: 1,
    strokeDasharray: "2,4"
  })), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 600,
    y: 68,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 10,
    fill: "#DCCA87",
    letterSpacing: 1
  }, "LOCALITY-AWARE (SHARED CONTEXT)")), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 565,
    y: 84,
    width: 70,
    height: 28,
    rx: 14,
    fill: "none",
    stroke: "#DCCA87",
    strokeOpacity: 0.6,
    strokeWidth: 1
  })), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 600,
    y: 102,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 10,
    fill: "#DCCA87"
  }, "Event")), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 600,
    y1: 112,
    x2: 600,
    y2: 132,
    stroke: "#DCCA87",
    strokeOpacity: 0.5,
    strokeWidth: 1
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "596,132 600,139 604,132",
    fill: "#DCCA87",
    fillOpacity: 0.5
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 545,
    y: 140,
    width: 110,
    height: 36,
    rx: 4,
    fill: "url(#ceBoxGrad)",
    stroke: "#DCCA87",
    strokeOpacity: 0.5,
    strokeWidth: 1.5
  })), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    x: 600,
    y: 162,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 12,
    fill: "#FFFFFF",
    fontWeight: 500
  }, "Planner")), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 600,
    y1: 176,
    x2: 600,
    y2: 196,
    stroke: "#DCCA87",
    strokeOpacity: 0.5,
    strokeWidth: 1
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "596,196 600,203 604,196",
    fill: "#DCCA87",
    fillOpacity: 0.5
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 520,
    y: 204,
    width: 160,
    height: 50,
    rx: 4,
    fill: "url(#ceBoxGrad)",
    stroke: "#DCCA87",
    strokeOpacity: 0.4,
    strokeWidth: 1
  })), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    x: 600,
    y: 226,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 11,
    fill: "#FFFFFF"
  }, "Blast Radius B(e)")), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    x: 600,
    y: 244,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 9,
    fill: "#AAAAAA"
  }, "activated subgraph \u2282 G")), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 600,
    y1: 254,
    x2: 600,
    y2: 274,
    stroke: "#DCCA87",
    strokeOpacity: 0.5,
    strokeWidth: 1
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "596,274 600,281 604,274",
    fill: "#DCCA87",
    fillOpacity: 0.5
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 520,
    y: 282,
    width: 160,
    height: 40,
    rx: 4,
    fill: "url(#ceBoxGrad)",
    stroke: "#DCCA87",
    strokeOpacity: 0.6,
    strokeWidth: 1.5
  })), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    x: 600,
    y: 306,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 12,
    fill: "#DCCA87",
    fontWeight: 500
  }, "Shared Context C*")), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 545,
    y1: 322,
    x2: 505,
    y2: 355,
    stroke: "#DCCA87",
    strokeOpacity: 0.4,
    strokeWidth: 1
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 580,
    y1: 322,
    x2: 575,
    y2: 355,
    stroke: "#DCCA87",
    strokeOpacity: 0.4,
    strokeWidth: 1
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 620,
    y1: 322,
    x2: 645,
    y2: 355,
    stroke: "#DCCA87",
    strokeOpacity: 0.4,
    strokeWidth: 1
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 655,
    y1: 322,
    x2: 715,
    y2: 355,
    stroke: "#DCCA87",
    strokeOpacity: 0.4,
    strokeWidth: 1
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 475,
    y: 356,
    width: 60,
    height: 32,
    rx: 3,
    fill: "url(#ceBoxGrad)",
    stroke: "#DCCA87",
    strokeOpacity: 0.3,
    strokeWidth: 1
  })), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    x: 505,
    y: 376,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 9,
    fill: "#FFFFFF"
  }, "Security")), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 545,
    y: 356,
    width: 60,
    height: 32,
    rx: 3,
    fill: "url(#ceBoxGrad)",
    stroke: "#DCCA87",
    strokeOpacity: 0.3,
    strokeWidth: 1
  })), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    x: 575,
    y: 376,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 9,
    fill: "#FFFFFF"
  }, "Correct.")), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 615,
    y: 356,
    width: 60,
    height: 32,
    rx: 3,
    fill: "url(#ceBoxGrad)",
    stroke: "#DCCA87",
    strokeOpacity: 0.3,
    strokeWidth: 1
  })), _text18 || (_text18 = /*#__PURE__*/React.createElement("text", {
    x: 645,
    y: 376,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 9,
    fill: "#FFFFFF"
  }, "Perf.")), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 685,
    y: 356,
    width: 60,
    height: 32,
    rx: 3,
    fill: "url(#ceBoxGrad)",
    stroke: "#DCCA87",
    strokeOpacity: 0.3,
    strokeWidth: 1
  })), _text19 || (_text19 = /*#__PURE__*/React.createElement("text", {
    x: 715,
    y: 376,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 9,
    fill: "#FFFFFF"
  }, "Testing")), _text20 || (_text20 = /*#__PURE__*/React.createElement("text", {
    x: 600,
    y: 406,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 9,
    fill: "#AAAAAA"
  }, "task-specific projections from shared context")), _text21 || (_text21 = /*#__PURE__*/React.createElement("text", {
    x: 600,
    y: 430,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 10,
    fill: "#DCCA87"
  }, "Cost: O(|B(e)| + N \xD7 p)")), _text22 || (_text22 = /*#__PURE__*/React.createElement("text", {
    x: 600,
    y: 446,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 9,
    fill: "#AAAAAA"
  }, "|B(e)| \u226A |G| under locality assumption")), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 460,
    width: 720,
    height: 28,
    rx: 4,
    fill: "none",
    stroke: "#DCCA87",
    strokeOpacity: 0.12,
    strokeWidth: 1
  })), _text23 || (_text23 = /*#__PURE__*/React.createElement("text", {
    x: 190,
    y: 478,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 9,
    fill: "#666666"
  }, "4N retrieval operations, redundant context")), _text24 || (_text24 = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 478,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 9,
    fill: "#DCCA87",
    opacity: 0.6
  }, "vs")), _text25 || (_text25 = /*#__PURE__*/React.createElement("text", {
    x: 600,
    y: 478,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 9,
    fill: "#DCCA87"
  }, "1 construction + N projections, minimal context")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContextEngineeringGraph);
export default __webpack_public_path__ + "static/media/context-engineering-graph.819818d21bf0e18230174507113094d1.svg";
export { ForwardRef as ReactComponent };